import { cn } from '@/lib/utils';
import { FunctionComponent, PropsWithChildren } from 'react';

interface Props extends PropsWithChildren {
  className?: string;
}

const DaasTableRowCell: FunctionComponent<Props> = ({ className, children }) => {
  return (
    <div className={cn('break-all border border-[#DDDDDD] p-3 flex justify-center items-center', className)}>
      {children}
    </div>
  );
};

export default DaasTableRowCell;
